import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { AppState } from '../../../store';
import { PickupBookingService } from '../../shared/services/pickup-booking.service';
import { Store } from '@ngrx/store';
import { BehaviorSubject, combineLatest, Observable, Subscription } from 'rxjs';
import { PickupService } from '../../../data/pickup.service';
import { Pickup } from '../../../models/pickup';
import { delay, filter, map, tap } from 'rxjs/operators';
import { pickupCancelRequest, pickupReset, pickupSetSelection } from '../../../store/pickup/pickup.actions';
import { selectPickupBusy, selectPickupSelection, selectPickupSuccess } from '../../../store/pickup/pickup.state';
import { SelectionModel } from '@angular/cdk/collections';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatListOption, MatSelectionList } from '@angular/material/list';
import { CourierNamePipe } from '../../shared/pipes/courier-name.pipe';
import { MatButton } from '@angular/material/button';
import { MatLine } from '@angular/material/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-cancel-pickup',
    templateUrl: './cancel-pickup.component.html',
    styleUrls: ['./cancel-pickup.component.scss'],
    imports: [MatProgressSpinner, MatSelectionList, MatListOption, MatLine, MatButton, AsyncPipe, CourierNamePipe, MatDialogTitle, MatDialogContent, MatDialogActions]
})
export class CancelPickupComponent implements OnInit, OnDestroy {

    pickups$: Observable<Pickup[]>;
    loading$ = new BehaviorSubject(true);
    success: Subscription;
    selectedPickups: string[];

    constructor(@Inject(MAT_DIALOG_DATA) data: { selectedPickups: string[] }, private dialogRef: MatDialogRef<CancelPickupComponent>,
                private store: Store<AppState>, private pickupBookingService: PickupBookingService, private pickupService: PickupService) {
        this.store.dispatch(pickupReset());
        this.store.dispatch(pickupSetSelection({ selection: data.selectedPickups }));
        this.selectedPickups = data.selectedPickups;
    }

    selection$ = this.store.select(selectPickupSelection);
    busy$ = this.store.select(selectPickupBusy);
    disableSubmit$ = combineLatest([
        this.loading$, this.selection$, this.busy$
    ]).pipe(
        map(([ loading, selection, busy ]) => busy || loading || selection.length === 0)
    );

    ngOnInit(): void {
        this.pickups$ = this.pickupService.getMultiple(this.selectedPickups).pipe(
            delay(0),
            tap(() => this.loading$.next(false))
        );
        this.success = this.store.select(selectPickupSuccess).pipe(filter((s => s === true))).subscribe(() => this.close());
    }

    ngOnDestroy(): void {
        this.success.unsubscribe();
    }

    selectionChange(selection: SelectionModel<MatListOption>): void {
        this.store.dispatch(pickupSetSelection({ selection: selection.selected.map(o => o.value) }));
    }

    close(): void {
        this.dialogRef.close();
    }

    submit(): void {
        this.store.dispatch(pickupCancelRequest());
    }
}
